import { Link } from "react-router-dom";

import "./components-css/not-found.css";

function NotFound() {
  return (
    <>
      <div className="centering-wrapper" style={{backgroundColor: '#000000'}}>
        <div className="max-width-container">    
          <div className="not-found-container">
            <h1 className="not-found-title">404</h1>
            <p className="not-found-subtitle">Página no encontrada</p>
            <p className="not-found-description">
              La página que estás buscando no existe o ha sido movida.
            </p>
            <Link to="/home" className="not-found-button">
              Volver al inicio
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default NotFound;